export enum ApiErrorId {
  AdminCanNotBeDeleted = 'AdminCanNotBeDeletedError',
  CurrentUserNotAllowed = 'CurrentUserNotAllowedError',
  DeploymentNotFound = 'DeploymentNotFoundError',
  EmptyDatasetCreationWithSplit = 'EmptyDatasetCreationWithSplitError',
  EmptyManifestSelection = 'EmptyManifestSelectionError',
  IncompatibleAlgorithm = 'IncompatibleAlgorithmError',
  IncompatibleExampleDefinition = 'IncompatibleExampleDefinitionError',
  InvalidPlatformConnection = 'InvalidPlatformException',
  InvitationLinkExpired = 'InvitationLinkExpiredError',
  JobNotFound = 'JobNotFoundError',
  JobNotRunning = 'JobNotRunningError',
  LastAdminNotAllowed = 'LastAdminNotAllowedError',
  LicenseInvalid = 'LicenseInvalidError',
  ProjectIdNotFound = 'ProjectIdNotFoundError',
  WorkflowNotFound = 'WorkflowNotFoundError',
}
